import { flattenMessages, initLocale } from '../../../helpers/Intl';
import * as EnglishUS from './en-US';
import * as SpanishMX from './es-MX';

const messages = {};
messages[EnglishUS.languageCode] = flattenMessages(EnglishUS.messages);
messages[SpanishMX.languageCode] = flattenMessages(SpanishMX.messages);

export default initLocale(messages);
